enum ChartType {
	NineBox = "9-Box Chart",
	BarChart = "Bar Chart",
	ColumnChart = "Column Chart",
	ScatterChart = "Scatter Chart",
	HistogramChart = "Histogram Chart",
	TrendlineChart = "Trendline Chart",
	PieChart = "Pie Chart",
	BubbleChart = "Bubble Chart",
	Table = "Table",
}

type ChartOptionKey = "column" | "min" | "max" | "rangeOption" | string;

const nineBoxRequiredFields = new Set(["summary_review_subject", "summary_employee_manager", "summary_employee_group"]);

enum ReportAnalyticsRbacPermissions {
	CreateReport = "report_analytics:createReport",
	ViewReportsListSharedWithManagers = "report_analytics:viewReportsListSharedWithManagers",
	ViewReportSharedWithManagers = "report_analytics:viewReportSharedWithManagers",
	CreateEmployeeReport = "report_analytics:createEmployeeReport",
	ViewEmployeeReport = "report_analytics:viewEmployeeReport",
	ViewReportsListSharedWithContributors = "report_analytics:viewReportsListSharedWithContributors",
	ViewReportSharedWithContributors = "report_analytics:viewReportSharedWithContributors",
}

export { ChartType, ChartOptionKey, nineBoxRequiredFields, ReportAnalyticsRbacPermissions };
